import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from './img/qr_code.jpg';
const _withScopeId = n => (_pushScopeId("data-v-b39d4862"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "top"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  class: "item"
};
const _hoisted_4 = {
  class: "logoArea"
};
const _hoisted_5 = {
  class: "logo"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "保达软件", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "qr_code"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "保达二维码"
})], -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "more"
}, "更多解决方案", -1));
const _hoisted_10 = {
  class: "item"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", {
  class: "title"
}, "产品中心", -1));
const _hoisted_12 = {
  class: "item_content"
};
const _hoisted_13 = {
  class: "item"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", {
  class: "title"
}, "服务支持", -1));
const _hoisted_15 = {
  class: "item_content"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item"
}, [/*#__PURE__*/_createElementVNode("h4", {
  class: "title"
}, "联系我们"), /*#__PURE__*/_createElementVNode("ul", {
  class: "item_content"
}, [/*#__PURE__*/_createElementVNode("li", null, "售前热线：18122752759"), /*#__PURE__*/_createElementVNode("li", null, "售后电话：19124214486"), /*#__PURE__*/_createElementVNode("li", null, "招商合作：18138730950"), /*#__PURE__*/_createElementVNode("li", null, "公司地址：广州市海珠区凤浦西路771号")])], -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bottom"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "container"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createTextVNode("保达科技-专业医疗门诊管理软件服务商    为医务室/卫生室、诊所、中医诊所/门诊、专科门诊部、综合门诊部等基层医疗机构提供专业诊所管理系统 ICP备案号： "), /*#__PURE__*/_createElementVNode("a", {
  href: "http://beian.miit.gov.cn",
  target: "_blank",
  rel: "nofollow"
}, "粤ICP备17003305号")])])], -1));
export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("footer", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("h4", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
    src: require('./img/logo.svg'),
    alt: "保达"
  }, null, 8, _hoisted_6)]), _hoisted_7]), _hoisted_8, _hoisted_9]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("ul", _hoisted_12, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: "/cloud"
  }, {
    default: _withCtx(() => [_createTextVNode("保达云诊所")]),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: "/clinic"
  }, {
    default: _withCtx(() => [_createTextVNode("保达门诊软件")]),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: "/pharmacy"
  }, {
    default: _withCtx(() => [_createTextVNode("药店管理软件")]),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: "/hospital"
  }, {
    default: _withCtx(() => [_createTextVNode("互联网医院系统")]),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: "/individuality"
  }, {
    default: _withCtx(() => [_createTextVNode("个性化定制服务")]),
    _: 1
  })])])]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("ul", _hoisted_15, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: "/medicare"
  }, {
    default: _withCtx(() => [_createTextVNode("医保代办申请")]),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: "/webhospital"
  }, {
    default: _withCtx(() => [_createTextVNode("互联网医院代办申请")]),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: "/approval"
  }, {
    default: _withCtx(() => [_createTextVNode("医疗许可证代办")]),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: "/medicine"
  }, {
    default: _withCtx(() => [_createTextVNode("互联网药品许可证代办")]),
    _: 1
  })])])]), _hoisted_16])]), _hoisted_17]);
}